<template>
	<div class="faceDom hidefaceDom" style="height: 100%">
		<div class="top_box">
			<div class="title-top">
				<img src="../../../../static/imgV2/breathe.gif" alt="">
				<div class="title-top-text">{{ languageJson.EventDetails }}</div>
			</div>
		</div>
		<div class="eventAuto">
			<div class="center-box">
				<div :style="{width: '100%',position: 'relative',zoom: sZoom}" ref="centerDom">
					<img :src="robotInfo.snapPhotos" :style="{ width: robotInfo.bace.imgList[0].width ? robotInfo.bace.imgList[0].width+'px' : '100%',height: robotInfo.bace.imgList[0].height ? robotInfo.bace.imgList[0].height+'px' : '100%' }" alt="">
					<div class="errDiv" v-if="robotInfo.bace.imgList[0].position" v-for="(obj, index) in robotInfo.bace.imgList[0].position.split(';')"
						:style="{width: (Number(obj.split(',')[2])-Number(obj.split(',')[0]))-3 + 'px',height: (Number(obj.split(',')[3])-Number(obj.split(',')[1]))-3 + 'px',top: Number(obj.split(',')[1]) + 'px',left: Number(obj.split(',')[0]) + 'px'}">
					</div>
				</div>
			</div>

			<div class="eventInfo">
				<div class="eventInfo-title">{{ languageJson.EventInformation }} <span v-if="!robotInfo.bace.isAddMisIdentification && robotInfo.bace.misIdentificationType == '1'" style="color: #FF6A6A;cursor: pointer;" @click="changeWrong()">{{ languageJson.IncorrectIdentification }}</span></div>
				<div class="eventInfo-table">
					<div class="table-div">{{ languageJson.eventType }}</div>
					<div class="table-div">{{ languageJson.ReportingTime }}</div>
					<div class="table-div">{{ languageJson.robotName }}</div>
					<div class="table-div">{{ languageJson.Status }}</div>
					<div class="table-div" v-if="robotInfo.bace.updDate">{{ languageJson.processingTime }}</div>
					<div class="table-div" v-if="robotInfo.bace.handleName">{{ languageJson.ProcessedBy }}</div>
				</div>

				<div class="eventInfo-table tbody">
					<div class="table-div">{{ robotInfo.bace.eName }}</div>
					<div class="table-div">{{ robotInfo.bace.insDate }}</div>
					<div class="table-div" @click="toRobotLink()"><el-button type="primary" size="mini">{{ robotInfo.bace.rName }}</el-button></div>
					<div class="table-div">{{ robotInfo.bace.resultsName }}</div>
					<div class="table-div" v-if="robotInfo.bace.updDate">{{ robotInfo.bace.updDate }}</div>
					<div class="table-div" v-if="robotInfo.bace.handleName">{{ robotInfo.bace.handleName}}</div>
				</div>
			</div>

			<div style="margin: 1%;" v-if="robotInfo.bace.remark">
				<div class="remoke-title">{{ languageJson.Notes }}：{{ robotInfo.bace.remark }}</div>
			</div>

			<div style="margin: 1%;">
				<div class="remoke-title">{{ languageJson.FacialInformation }}</div>
			</div>

			<div class="userLog">
				<div class="userLog-img">
					<img :src="robotInfo.snapPhotos" alt="">
					<div>{{ languageJson.IdentifyImages }}</div>
				</div>
				<div class="userLog-img">
					<div class="yuan"> {{ robotInfo.similarity }}%</div>
					<div>{{ languageJson.Familiarity }}</div>
				</div>
				<div class="userLog-img">
					<img :src="robotInfo.registerPhotos" alt="">
					<div>{{ languageJson.RegistrationImage }}</div>
				</div>
			</div>

			<div class="eventInfo">
				<div class="eventInfo-table">
					<div class="table-div">{{ languageJson.name }}</div>
					<div class="table-div">{{ languageJson.sex }}</div>
					<div class="table-div">{{ languageJson.age }}</div>
					<div class="table-div">{{ languageJson.PersonnelType }}</div>
					<div class="table-div">{{ languageJson.IDtype }}</div>
					<div class="table-div">{{ languageJson.IDNO }}</div>
				</div>

				<div class="eventInfo-table tbody">
					<div class="table-div">{{ robotInfo.name }}</div>
					<div class="table-div">{{ robotInfo.sex ? (robotInfo.sex == '1' ? languageJson.sexWoman : languageJson.sexMan) : '--' }}</div>
					<div class="table-div">{{ countAge(robotInfo.birthDay) }}</div>
					<div class="table-div">{{ robotInfo.personTypeId }}</div>
					<div class="table-div">{{ robotInfo.idType }}</div>
					<div class="table-div">{{ robotInfo.idNumber ? robotInfo.idNumber : '--' }}</div>
				</div>
			</div>

			<div v-if="type != 'admin'">
				<div v-if="robotInfo.results != '1' && robotInfo.results != '3' && robotInfo.results != '5'">
					<div style="margin: 1%;">
						<div class="remoke-title">{{ languageJson.Notes }}</div>
						<el-input type="textarea" @focus="ruleForm.remark = ''" :rows="3" :placeholder="languageJson.pleaseEnterContent" maxlength="200" show-word-limit v-model="ruleForm.remark"></el-input>
					</div>
					<div style="display: flex;width: 100%;align-items: center;justify-content: center;padding-bottom: 1vw;">
						<div class="btn1" @click='doHandle()'>{{ languageJson.DetermineProcessing }}</div>
						<div class="btn1 btn2" @click='handleReport()'>{{ languageJson.ProcessAndReport }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import marquee from '@/components/marquee.vue'
	import {
		getItem
	} from '@/utils/auth'
	import {
		handleEvent,
		handleEventReport
	} from '@/api/admin'
	export default {
		name: '',
		data() {
			return {
				languageJson: languageJson,
				ruleForm: {
					remark: languageJson.Properlyhandled
				},
				sZoom: 1
			}
		},
		props: {
			robotInfo: null,
			type: String,
			robotID: String
		},
		components: {
			marquee
		},
		mounted() {
		},
		methods: {
			toRobotLink() {
				let that = this
				if (!that.robotID) {
					that.$router.push({
						name: 'detail',
						query: {
							robotId: that.robotInfo.bace.robotId,
							type: that.type
						}
					})
				} else {
					if (that.robotID != that.robotInfo.bace.robotId) {
						location.href = location.href.split('?')[0] + `?robotId=${that.robotInfo.bace.robotId}&type=${that.type}`
						location.reload()
					}
				}
			},
			changeWrong() {
				this.$emit('wrong',true)
			},
			doHandle() {
				let that = this
				if (!that.ruleForm.remark) {
					that.$notify({
						title: languageJson.PleaseProcessing,
						type: 'warning'
					})
					return false
				} else {
					handleEvent({
						eventId: that.robotInfo.bace.eventId,
						userId: getItem('userInfo').staffId,
						tenantInfoId: getItem('tenantInfoId'),
						remark: that.ruleForm.remark
					}).then(res => {
						that.$notify({
							title: languageJson.successful,
							type: 'success'
						})
						that.ruleForm.remark = ""
						that.close()
					})
				}
			},
			handleReport() {
				let that = this
				if (!that.ruleForm.remark) {
					that.$notify({
						title: languageJson.PleaseProcessing,
						type: 'warning'
					})
					return false
				} else {
					handleEventReport({
						eventId: that.robotInfo.bace.eventId,
						eName: that.robotInfo.bace.eName,
						number: that.robotInfo.bace.number,
						remark: that.ruleForm.remark,
						userId: getItem('userInfo').staffId,
						staffName: getItem('userInfo').sName,
						tenantInfoId: getItem('tenantInfoId')
					}).then(res => {
						that.$notify({
							title: languageJson.successful,
							type: 'success'
						})
						that.ruleForm.remark = ""
						that.close()
					})
				}
			},
			close() {
				this.$emit('closeEventFace', true)
			},
			countAge(birthDay) {
				if (birthDay) {
					let births = birthDay.split("-");
					let now = new Date();
					if ((now.getMonth() + 1) < births[1]) {
						return (now.getFullYear() - births[0]) - 1;
					}
					return now.getFullYear() - births[0];
				} else {
					return "--";
				}
			}
		},
		watch: {
			robotInfo: {
				deep: true,
				immediate: true,
				handler(val, oldVal) {
					let that = this
					that.$nextTick(() => {
						if (that.$refs.centerDom) {
							if (val.bace.imgList && val.bace.imgList[0].width) {
								that.sZoom = window.innerWidth*0.55*0.84 / val.bace.imgList[0].width
							}
						}
					})
					that.ruleForm.remark = languageJson.Properlyhandled
				}
			}
		}
	}
</script>

<style scoped lang="less">

	.faceDom /deep/ .el-button--mini, .el-button--mini.is-round {
		padding: 2px 10px;
	}

	.faceDom /deep/.el-textarea__inner {
		color: #b0d8ff;
		background-color: rgba(0, 15, 50, 0.6);
		border: 1px solid rgba(0, 180, 255, 0.25);
	}

	.faceDom /deep/ .el-form-item {
		margin-bottom: 0px;
	}

	.faceDom /deep/.el-form-item__label {
		color: white;
		font-size: 0.7vw;
		line-height: 25px;
	}

	.faceDom /deep/ .el-textarea__inner {
		font-size: 0.7vw;
	}

	.eventAuto {
		position: absolute;
		height: 90%;
		width: 79.5%;
		overflow-y: auto;
		overflow-x: hidden;
	}

	::-webkit-scrollbar-track {
		border-radius: 10px;
		background-color: rgba(0, 20, 60, 0.5);
	}

	/*定义滑块 内阴影+圆角*/
	::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 6px rgba(0, 180, 255, 0.2);
		background-color: rgba(0, 100, 180, 0.4);
		cursor: pointer;
	}

	.userLog {
		text-align: center;
		display: flex;
		align-items: flex-end;
		justify-content: center;
		font-size: 0.8vw;
		color: #9CC3FF;

		&-img {
			display: flex;
			flex-direction: column;
			align-items: center;
			margin: 0 1vw;

			img {
				width: 5vw;
				height: 5vw;
				margin-bottom: 0.5vw;
			}

		}
	}

	.yuan {
		width: 4vw;
		height: 4vw;
		border-radius: 50%;
		font-size: 0.75vw;
		background: linear-gradient(145deg, rgba(0, 60, 120, 0.8), rgba(0, 30, 80, 0.9));
		border: 1px solid rgba(0, 240, 255, 0.3);
		display: flex;
		align-items: center;
		justify-content: center;
		color: #00f0ff;
		font-weight: 600;
		margin-bottom: 1vw;
		box-shadow: 0 0 12px rgba(0, 240, 255, 0.15);
	}

	.remoke-title {
		text-align: left;
		margin: .2vw 0;
		color: #9CC3FF;
		font-size: .7vw;
	}

	.errDiv {
		border: 2px solid #ffd400;
		position: absolute;
		background-color: transparent;
		padding: 0;
	}

	.eventInfo {
		margin: 1vw 0 .4vw .4vw;
		color: #b0d8ff;
		font-size: .7vw;
		&-title {
			text-align: left;
			margin-bottom: .2vw;
		}
		&-table {
			width: 99%;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background-color: rgba(0, 40, 90, 0.5);
			border: 1px solid rgba(0, 180, 255, 0.25);
			border-right: none;
		}

		.tbody {
			background-color: transparent;
			border: 1px solid rgba(0, 180, 255, 0.25);
			border-top: none;
			border-right: none;
		}

		.table-div {
			padding: 0.3vw 0;
			border-right: 1px solid rgba(0, 180, 255, 0.25);
			text-align: center;
			width: 30%;
		}
	}

	.title-top {
		display: flex;
		color: #fff;
		font-size: 1vw;
		align-items: center;
		justify-content: flex-start;
		&-text {
			color: #D6E6FF;
			font-size: 0.8vw;
			font-weight: 600;
		}

		img {
			width: 0.7vw;
			margin-right: 0.3vw;
		}
	}

	.faceDom {
		width: 100%;
		height: 100%;

		.top_box {
			display: flex;
			justify-content: space-between;
			margin: 1vw;
			color: #fff;
			font-size: 1vw;
			height: 1vw;

			.title-top {
				display: flex;
				color: #fff;
				font-size: 1vw;
				align-items: center;
				justify-content: flex-start;
				&-text {
					color: #e0f0ff;
					font-size: 0.8vw;
					font-weight: 600;
					text-shadow: 0 0 8px rgba(0, 240, 255, 0.4);
				}

				img {
					width: 0.7vw;
					margin-right: 0.3vw;
					filter: drop-shadow(0 0 4px rgba(0, 240, 255, 0.5));
				}
			}

		}

		.center-box {
			width: 99%;
			margin: 5px auto;
			display: flex;
			align-items: flex-start;
			justify-content: space-around;
		}

		.baceName {
			width: 100%;
			display: flex;
			align-items: center;
			margin: 2% 1%;
			justify-content: space-between;
			font-size: 0.7vw;
			color: white;

			.divText {
				width: 25%;
				padding-left: 1vw;
				text-align: left;
			}

		}

		.btn1 {
			width: 10vw;
			padding: 0.4vw 0;
			margin-right: 16px;
			font-size: 0.7vw;
			font-weight: 700;
			text-align: center;
			cursor: pointer;
			color: #b0d8ff;
			background: linear-gradient(180deg, rgba(0, 60, 120, 0.6), rgba(0, 30, 80, 0.8));
			border: 1px solid rgba(0, 180, 255, 0.3);
			border-radius: 4px;
			transition: all 0.3s ease;

			&:hover {
				background: linear-gradient(180deg, rgba(0, 100, 200, 0.7), rgba(0, 50, 120, 0.9));
				border-color: rgba(0, 240, 255, 0.5);
				color: #e0f0ff;
				box-shadow: 0 0 12px rgba(0, 240, 255, 0.2);
			}
		}

		.btn2 {
			margin-right: 0;
		}
	}

	.hidefaceDom {
		background: none;
		border-radius: 0;
	}
</style>



// WEBPACK FOOTER //
// src/page/robotDetail/components/eventFaceOpen.vue